import { Navigate, type NavigateProps } from 'react-router'

import { useLocale } from './LocaleProvider'
import { localizeUrl, stripLocaleFromPath } from './utils'


export interface LocalizedNavigateProps extends Omit<NavigateProps, 'to'> {
  to: string
  /** Skip locale prefix (for external links or special cases) */
  skipLocale?: boolean
}

/**
 * A wrapper around Navigate that automatically adds the locale prefix
 */
export function LocalizedNavigate ({ to, skipLocale = false, ...props }: LocalizedNavigateProps) {
  const { locale } = useLocale()

  if (skipLocale) {
    return <Navigate to={to} {...props} />
  }

  // Handle external URLs
  if (to.startsWith('http://') || to.startsWith('https://') || to.startsWith('//')) {
    return <Navigate to={to} {...props} />
  }

  // Handle hash-only links
  if (to.startsWith('#')) {
    return <Navigate to={to} {...props} />
  }

  // Strip existing locale and add current one
  const cleanPath = stripLocaleFromPath(to)
  const localizedTo = localizeUrl(cleanPath, locale)

  return <Navigate to={localizedTo} {...props} />
}
